// Turning a run's events into the rows the screen shows (plan
// brain-conversacion-en-segundo-plano, 3.4). Apart from the component so it can
// be tested without rendering, and so fast refresh keeps working.

import type { RunEvent } from '@/services/brainApi'

export type StepRow =
  | { kind: 'thought'; text: string }
  | { kind: 'tool'; name: string; state: 'running' | 'done' | 'failed' }

/** The rows to paint, from the events in the order they arrived.
 *
 * A tool reports when it starts and when it ends; that is **one** row that
 * changes state, not two. When the same tool is called twice, each end closes
 * the first one still open. A model answer with no thinking says nothing worth
 * showing and is left out.
 */
export function rowsOf(events: RunEvent[]): StepRow[] {
  const rows: StepRow[] = []
  for (const event of events) {
    if (event.kind === 'llm.response') {
      if (event.thinking) rows.push({ kind: 'thought', text: event.thinking })
      continue
    }
    if (event.kind === 'tool_call.started') {
      rows.push({ kind: 'tool', name: event.tool_name, state: 'running' })
      continue
    }
    const state = event.kind === 'tool_call.error' ? 'failed' : 'done'
    const open = rows.find(
      (row): row is Extract<StepRow, { kind: 'tool' }> =>
        row.kind === 'tool' && row.name === event.tool_name && row.state === 'running',
    )
    if (open) open.state = state
    else rows.push({ kind: 'tool', name: event.tool_name, state })
  }
  return rows
}
